var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.basicSurveyDetails.title != ""
      ? _c("div", { staticClass: "single-quesion-box" }, [
          _c("h3", {
            domProps: { innerHTML: _vm._s(_vm.basicSurveyDetails.title) }
          }),
          _c("p", [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.basicSurveyDetails.description)
              }
            })
          ])
        ])
      : _vm._e(),
    _vm.surveyQuestionAnswers.length > 0
      ? _c(
          "div",
          _vm._l(_vm.surveyQuestionAnswers, function(question, qi) {
            return _c("QuestionReview", {
              key: qi,
              attrs: { question: question, questionNumber: qi + 1, level: 0 }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }